// Friends bindings — the accepted-friendship graph. Mirrors GET /friends
// (backend/app/api/v1/friends.py) which returns FriendSummary rows. Used to
// populate the "send minutes" and (future) "share with a friend" pickers.
import { api } from "./client";

export interface Friend {
  user_id: string;
  username?: string | null;
  display_name: string;
  friends_since?: string;
}

export function getFriends(): Promise<Friend[]> {
  return api.get<Friend[]>("/friends");
}
